import React from 'react';
import {
  EllipsisForTrans,
  useDomainIntent,
} from '@wix/package-picker-shared-eclipse';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { useTitleEllipsisMaxWidth } from './useTitleEllipsisMaxWidth';

export function useDomainNamePageTitle(titleKey: string): React.ReactNode {
  const { t, Trans } = EclipsePackagePickerModule.internals.useTranslations();
  const { shouldShowDomainNameInTitle, domainName } = useDomainIntent();

  const probeText = t(titleKey, { domainName: '' }).replace(/<[^>]+>/g, '');
  const { maxWidth, probe } = useTitleEllipsisMaxWidth(probeText);

  if (!shouldShowDomainNameInTitle || !domainName) {
    return null;
  }

  return (
    <>
      {probe}
      <Trans
        i18nKey={titleKey}
        values={{ domainName }}
        components={{
          ellipsis: (
            <EllipsisForTrans
              maxWidth={maxWidth}
              position="bottom"
              as="span"
              componentProps={{}}
            />
          ),
        }}
      />
    </>
  );
}
